import { render } from "./SequencesSelect.vue?vue&type=template&id=8d93c9a0&ts=true"
import script from "./SequencesSelect.vue?vue&type=script&lang=ts"
export * from "./SequencesSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__